export enum WorkOrderStatus {
  New = "New",
  Pending = "Pending",
  InProgress = "InProgress",
  Hold = "Hold",
  Complete = "Complete",
  Cancelled = "Cancelled",
  AtRisk = "AtRisk",
  Late = "Late",
}
